import React from "react";
import { useI18n } from "@core/i18n/i18n";
import NoProgramsIcon from "@assets/icons/no-programs.svg";
import { useNavigate } from "@core/routing/use-navigate";
import { MessageContainer } from "@ui/components/common/message-container";
import { RoutesPath } from "@ui/navigation/routes";

export const EmptyTabs: React.FC = () => {
	const { format } = useI18n();
	const navigate = useNavigate();

	return (
		<MessageContainer
			style={{ flexGrow: 1, padding: "72px 32px" }}
			iconSvg={NoProgramsIcon}
			title={format("templateListing.empty.title")}
			description={format("templateListing.empty.description.v2_6")}
			cta={{
				label: format("templateListing.createProgramButton"),
				onClick: () => {
					navigate(RoutesPath.TemplateBuilder);
				},
			}}
		/>
	);
};
